import styled from "styled-components";

import { IThemeProps } from "@/styles/Theme";

export const Stage = styled.div<IThemeProps>`
  display: flex;
  width: 100%;
  max-width: ${(props: IThemeProps) => props.theme.globals.maxInteractionWidth};
  min-height: ${(props: IThemeProps) =>
    props.theme.globals.minInteractionHeight};
  margin: 0 auto;
  padding: ${(props: IThemeProps) => props.theme.spacing.desktop.s200}px;
  overflow: hidden;

  @media ${(props: IThemeProps) => props.theme.breakpoints.mobile} {
    padding: ${(props: IThemeProps) => props.theme.spacing.mobile.s200}px;
  }
`;

export const Wrapper = styled.div<IThemeProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  background: ${(props: IThemeProps) => props.theme.colors.defaultBackground};
  width: 100%;
  overflow: hidden;

  @media ${(props: IThemeProps) => props.theme.breakpoints.mobile} {
    width: 100vw;
  }
`;

export const Relative = styled.div`
  position: relative;
`;

export const Group = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
`;
